import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-payments-gateway-properties-card',
  templateUrl: './payments-gateway-properties-card.component.html',
  styleUrls: ['./payments-gateway-properties-card.component.scss']
})
export class PaymentsGatewayPropertiesCardComponent implements OnInit, OnChanges {

  @Input() gateway;
  @Input() properties;
  data;
  updateGatewayInfoSubscription: Subscription;

  constructor(private paymentsService: PaymentsService,
              private snackbarService: SnackBarService) {
                this.data = [];
              }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.properties) {
      this.data = this.parseData(this.properties);
    }
  }

  public keyvalueOutputChanged(e) {
    this.updateGatewayProperties(this.gateway.InternalId, e);
  }

  public updateGatewayProperties(internalId, properties) {
    this.updateGatewayInfoSubscription = this.paymentsService.updateGatewayProperties(internalId, properties).subscribe(
      (res) => {
        this.snackbarService.open('gateways-page.snackbar messages.update gateway success', 'success');
        this.paymentsService.refreshGateway();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.paymentsService.refreshGateway();
      }
    );
  }

  private parseData(data) {
    const d = [];
    Object.entries(JSON.parse(this.properties)).forEach(v => {
      d.push({ key: v[0], value: v[1] });
    });
    return d;
  }

}
